<template>
  <div class="select">
    <div class="title">{{ title }}</div>
    <multiselect
      class="field"
      type="text"
      track-by="id"
      label="title"
      :multiple="multiple"
      :value="select_value"
      :loading="!loaded"
      :options="list"
      @input="$emit('input', $event)"/>
  </div>
</template>
<script>
  export default {
    name: "select-dictionary",
    props: {
      multiple: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        required: true,
      },
      value: {
        type: [Number, Array],
        default: null,
      },
      loaded: {
        type: Boolean,
        default: true,
      },
      error: {
        type: [Error, String],
        default: null,
      },
      list: {
        type: Array,
        default: [],
      },
    },
    computed: {
      select_value () {
        if (!this.value || !this.list.length) return null;
        if (typeof this.value === 'number') return this.list.find(item => item.id === this.value);
        return this.value.map(id => this.list.find(item => item.id === id))
      }
    }
  }
</script>
<style scoped lang="scss">
  .select {
    margin: 10px 0;
    .title {
      margin: 5px 0;
    }
    .field {
      max-width: 385px;
      margin: 5px 0;
    }
  }
</style>